import type { AxiosResponse } from 'axios';
import type { UserNotification } from '@/models/UserNotification';
import type { NotificationType } from '@/models/NotificationType';
import { api_notificacion } from '@/api/axiosConfig';
import { UserNotificationConfig } from '@/models/UserNotificationConfig';
import { listData } from '@/models/ListDataResponse';


export default{
    async list(user:number): Promise<listData<UserNotification[]>> {
        return api_notificacion.get('/api/notifications?user='+user,).then((response: AxiosResponse) => {
            return response.data;
        }); 
    },
    async listConfig(user:number): Promise<UserNotificationConfig[]> {
        return api_notificacion.get('/api/user-notification-config?user='+user).then((response: AxiosResponse) => {
            return response.data;
        }); 
    },
    // Nuevo método para actualizar la configuración de notificación
    async updateNotificationConfig(data:UserNotificationConfig): Promise<UserNotification> {
        return api_notificacion.patch('/api/user-notification-config/' + data.id, data).then((response: AxiosResponse) => {
            return response.data;
        });
    },
}